import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsSystemDaydreamIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_system_daydream"}/>
}
